import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    // Check if clipboard API is available
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.textValue).then(() => {
        this.showSuccessFeedback()
      }).catch(err => {
        console.error('Failed to copy: ', err)
        this.fallbackCopy()
      })
    } else {
      this.fallbackCopy()
    }
  }

  showSuccessFeedback() {
    const copyIcon = this.element.querySelector('.copy-icon')
    const checkIcon = this.element.querySelector('.check-icon')

    if (copyIcon && checkIcon) {
      copyIcon.classList.add('hidden')
      checkIcon.classList.remove('hidden')

      setTimeout(() => {
        copyIcon.classList.remove('hidden')
        checkIcon.classList.add('hidden')
      }, 1000)
    }
  }

  fallbackCopy() {
    // Create a temporary textarea element
    const textArea = document.createElement('textarea')
    textArea.value = this.textValue
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)

    // Select and copy the text
    textArea.focus()
    textArea.select()

    try {
      const successful = document.execCommand('copy')
      if (successful) {
        this.showSuccessFeedback()
      } else {
        console.error('Fallback copy failed')
      }
    } catch (err) {
      console.error('Fallback copy error:', err)
    }

    // Clean up
    document.body.removeChild(textArea)
  }
}